<div provide-parent-form>
		
	<bb-form-element [form]="form" invalidMessage="The title is required" label="{{'TITLE' | translate}}">
		<input [(ngModel)]="creative.title" type="text" required name="title" />
	</bb-form-element>
	
	<bb-form-element [form]="form" label="{{'DESCRIPTION' | translate}}">
		<textarea [(ngModel)]="creative.description" type="text" name="creativeDescription">{{creative.description}}</textarea>
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'CLICK_THROUGH_URL' | translate}}">
		<input [(ngModel)]="creative.deeplink" type="text" name="deeplink"/>
	</bb-form-element>	

	<bb-form-element [form]="form" label="{{'THIRD_PARTY_TRACKING_URLS' | translate}}">
		<div class="input" *ngIf="!isString(creative.eventTrackers)">
			<div class="tracker-row" *ngFor="let tracker of creative.eventTrackers;let i = index">
				<bb-select [(ngModel)]="tracker.eventType" class="tracker-type" [ngModelOptions]="{standalone: true}">
					<option value="" default="true">{{ 'SELECT_TYPE' | translate }}</option>
					<option value="start">{{ 'START' | translate }}</option>
					<option value="clickTracking">{{ 'CLICK_TRACKING' | translate }}</option>
					<option value="firstQuartile">{{ 'FIRST_QUARTILE' | translate }}</option>
					<option value="midpoint">{{ 'MIDPOINT' | translate }}</option>
					<option value="thirdQuartile">{{ 'THIRD_QUARTILE' | translate }}</option>
					<option value="complete">{{ 'COMPLETE' | translate }}</option>
					<option value="skip">{{ 'SKIP' | translate }}</option>
					<option value="mute">{{ 'MUTE' | translate }}</option>
					<option value="unmute">{{ 'UNMUTE' | translate }}</option>
					<option value="rewind">{{ 'REWIND' | translate }}</option>
					<option value="pause">{{ 'PAUSE' | translate }}</option>
					<option value="resume">{{ 'RESUME' | translate }}</option>
					<option value="fullscreen">{{ 'FULLSCREEN' | translate }}</option>
					<option value="exitFullscreen">{{ 'EXIT_FULLSCREEN' | translate }}</option>
				</bb-select>
				<input type="text" [(ngModel)]="tracker.url" [name]="'url_'+i" class="tracker-url" />
				<div class="remove-tracker" (click)="removeTracker(i)">
					<i class="fa fa-times"></i>
				</div>
			</div>
			<span class="button" (click)="addTracker()" ><i class="fa fa-plus"></i>{{'ADD_EVENT_TRACKER' | translate}}</span>
		</div>
	</bb-form-element>

	<h3>{{ 'VPAID_SETTINGS' | translate }}</h3>
	
	<bb-form-element [form]="form" label="{{'CLICKABLE_ENDSCREEN' | translate}}">
		<bb-check [(ngModel)]="creative.clickableEndscreen" name="clickableEndscreen"></bb-check>
	</bb-form-element>
	
	<bb-form-element [form]="form" label="{{'CREATIVE_SHOULD_REPLAY' | translate}}">
		<bb-check [(ngModel)]="creative.shouldReplay" name="shouldReplay"></bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'CREATIVE_SHOULD_PLAY_INLINE' | translate}}" [hasPublicationField]="'shouldPlayInline'">
		<bb-check [(ngModel)]="creative.shouldPlayInline" name="shouldPlayInline"></bb-check>
	</bb-form-element>

	<div class="omid-settings">
		<h3>{{ 'OMID_SETTINGS' | translate }}</h3>
		<div class="ad-verification" *ngFor="let adVerification of creative?.omidAdVerifications; index as i;">
			<h4>{{ 'AD_VERIFICATION' | translate }} #{{ i + 1 }} <span class="remove-ad-verification" (click)="removeAdVerification(i)"><i class="fa fa-times"></i></span></h4>
			<bb-form-element [form]="form" label="{{'OMID_VERIFICATION_VENDOR' | translate}}">
				<input [(ngModel)]="creative.omidAdVerifications[i].vendor" type="text" [name]="'vendor-' + i" required />
			</bb-form-element>

			<bb-form-element [form]="form" label="{{'OMID_VERIFICATION_SCRIPT_URL' | translate}}">
				<input [(ngModel)]="creative.omidAdVerifications[i].scriptUrl" type="text" [name]="'scripturl-' + i" required />
			</bb-form-element>

			<bb-form-element [form]="form" label="{{'OMID_VERIFICATION_PARAMETERS' | translate}}">
				<textarea [(ngModel)]="creative.omidAdVerifications[i].parameters" [name]="'parameters-' + i"></textarea>
			</bb-form-element>
			<hr/>
		</div>

		<span class="button" (click)="addAdVerification()"><i class="fa fa-plus"></i>{{'ADD_AD_VERIFICATION' | translate}}</span>
	</div>
</div>
